/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

const RefDesModal = (props) => {
  const [ref_des_separator_type, setRefDesSeparatorType] = useState('comma');
  const [other_ref_des_separator, setOtherRefDesSeparator] = useState('');
  const [ref_des_range_separator_type, setRefDesRangeSeparatorType] =
    useState('dash');
  const [other_ref_des_range_separator, setOtherRefDesRangeSeparator] =
    useState('');

  const {
    ref_des_separator,
    ref_des_range_separator,
    show,
    onHide,
    onSaveRefs,
  } = props;

  const onAccept = () => {
    const new_ref_des_separator =
      ref_des_separator_type === 'other' ? other_ref_des_separator : ',';
    const new_ref_des_range_separator =
      ref_des_range_separator_type === 'other'
        ? other_ref_des_range_separator
        : '-';
    onSaveRefs(new_ref_des_separator, new_ref_des_range_separator);
  };

  const onShowModal = () => {
    if (ref_des_separator !== ',') {
      setOtherRefDesSeparator(ref_des_separator);
      setRefDesSeparatorType('other');
    }

    if (ref_des_range_separator !== '-') {
      setOtherRefDesRangeSeparator(ref_des_range_separator);
      setRefDesRangeSeparatorType('other');
    }
  };

  return (
    <Modal show={show} size='sm' centered onShow={onShowModal} onHide={onHide}>
      <Modal.Body className='modal-ref-designator'>
        <label>REF DES FIELD SEPARATOR:</label>
        <div className='row'>
          <div className='col-5'>
            <div className='mb-3 form-check'>
              <input
                type='radio'
                className='form-check-input'
                name='ref_des_separator'
                checked={ref_des_separator_type === 'comma'}
                value='comma'
                onChange={() => setRefDesSeparatorType('comma')} />
              <label className='form-check-label'>Comma (,)</label>
            </div>
          </div>
          <div className='col-3'>
            <div className='mb-3 form-check'>
              <input
                type='radio'
                className='form-check-input'
                name='ref_des_separator'
                checked={ref_des_separator_type === 'other'}
                value='other'
                onChange={() => setRefDesSeparatorType('other')} />
              <label className='form-check-label'>Other</label>
            </div>
          </div>
          <div className='col-4'>
            <input
              className='form-control form-control-sm'
              type='text'
              placeholder='Type'
              value={other_ref_des_separator}
              onChange={(e) => setOtherRefDesSeparator(e.target.value)} />
          </div>
        </div>
        <label>REF DES RANGE SEPARATOR:</label>
        <div className='row'>
          <div className='col-5'>
            <div className='mb-3 form-check'>
              <input
                type='radio'
                className='form-check-input'
                name='ref_des_range_separator'
                checked={ref_des_range_separator_type === 'dash'}
                value='dash'
                onChange={() => setRefDesRangeSeparatorType('dash')} />
              <label className='form-check-label'>Dash (-)</label>
            </div>
          </div>
          <div className='col-3'>
            <div className='mb-3 form-check'>
              <input
                type='radio'
                className='form-check-input'
                name='ref_des_range_separator'
                checked={ref_des_range_separator_type === 'other'}
                value='other'
                onChange={() => setRefDesRangeSeparatorType('other')} />
              <label className='form-check-label'>Other</label>
            </div>
          </div>
          <div className='col-4'>
            <input
              className='form-control form-control-sm'
              type='text'
              placeholder='Type'
              value={other_ref_des_range_separator}
              onChange={(e) => setOtherRefDesRangeSeparator(e.target.value)} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-secondary' onClick={onHide}>
          Cancel
        </button>
        <button type='button' className='btn btn-primary' onClick={onAccept}>
          Accept
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default RefDesModal;
